import { defineMessages } from 'react-intl';

export default defineMessages({
  actionsOnFile: {
    id: 'poc.dossierWorkflow.actionsOnFile',
    defaultMessage: 'Actions sur le dossier',
  },
  noActionNeeded: {
    id: 'poc.dossierWorkflow.noActionNeeded',
    defaultMessage: 'Aucune action requise',
  },
  noAvailableAction: {
    id: 'poc.dossierWorkflow.noAvailableAction',
    defaultMessage: 'Aucune action disponible',
  },
  comment: {
    id: 'poc.dossierWorkflow.comment',
    defaultMessage: 'Commentaire',
  },
  customerComment: {
    id: 'poc.dossierWorkflow.customerComment',
    defaultMessage: 'Commentaire client',
  },
  fillComment: {
    id: 'poc.dossierWorkflow.fillComment',
    defaultMessage: 'Ajouter un commentaire',
  },
  fillCustomerComment: {
    id: 'poc.dossierWorkflow.fillCustomerComment',
    defaultMessage: 'Commentaire visible client',
  },
  validate: {
    id: 'poc.dossierWorkflow.validate',
    defaultMessage: 'Valider',
  },
  submitSuccess: {
    id: 'poc.dossierWorkflow.submitSuccess',
    defaultMessage: 'Transition simulée : {fromState} → {toState}',
  },
  stateDate: {
    id: 'poc.dossierWorkflow.stateDate',
    defaultMessage: 'Le : {date}',
  },
});
